/**
 * Created by Jerker Nord on 2021-01-27.
 */
import { AssetQualityLevel, IResourcesGroupConfig, SpriteSheetNameExtension } from "@nolimitcity/slot-game/bin/asset/Asset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import { ImgLoader } from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import { Possessed } from "./Possessed";

export class PossessedGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";

    static IMAGES_LOGO: string = "resources/images/introLogo.png";
    static IMAGES_LOGO_FS: string = "resources/images/introLogo_2.png";

    public static REEL_FRAME: string = "ui/Reel_area_frame";

    // Spines
    static SYMBOL_WIN_TOGGLE_FIRE: string = "spine/individualWin.json";
    static WIN_FIRE: string = "spine/initialWin.json";

    static SYMBOL_REVEAL_ANIMATION: string = "spine/symReveal.json";
    static MULTIPLIER_NUMBER_ANIMATION: string = "spine/multiplierNum.json";

    static WILD_NUDGE_ANIMATION: string = "spine/xNudge.json";
    static WILD_EXPANDED_ANIMATION: string = "spine/crawlGril.json";
    static WILD_EXPAND_REEL_ANTICIPATION: string = "spine/anticipation_Nudge.json";
    static WILD_EXPAND_BLACK_PARTICLE: string = "spine/blackParticle.json";

    static BACKGROUND_ANIMATION: string = "spine/mainBg.json";
    static FS_INTRO_ANIMATION: string = "spine/fsIntro.json";
    static BED_GRIL: string = "spine/bedGril.json";

    static REEL_CROSS_ANIMATION: string = "spine/frameCross.json";

    static COMMON_REVEAL_ANIMATION: string = "spine/revealCommon.json";

    static HOTZONE_ANIMATION: string = "spine/hotZone.json";
    static SCATTER_ANIMATION: string = "spine/scatter.json";

    static ACTIVATOR_SYM_SPINE: string = "spine/activatorUIsym.json";
    static CRUCIFIX_SYMBOL_SPINE: string = "spine/UIsym.json";

    static BIG_WIN_SPINE: string = "spine/bigwin.json";

    static SCATTER_REEL_ANTICIPATION_SPINE: string = "spine/anticipation_SC.json";

    static WIN_CAP_ANIMATION: string = "spine/capWin.json";

    static BACKGROUND_FIRE_ANIMATION: string = "spine/bgFire.json";

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(PossessedGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    //new TextureAsset("main5", "sheets/main/main5.json"),
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    //new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    //new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    //new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset(PossessedGameAssets.WIN_FIRE, PossessedGameAssets.WIN_FIRE),
                    new SpineAsset(PossessedGameAssets.SYMBOL_WIN_TOGGLE_FIRE, PossessedGameAssets.SYMBOL_WIN_TOGGLE_FIRE),
                    new SpineAsset(PossessedGameAssets.BACKGROUND_ANIMATION, PossessedGameAssets.BACKGROUND_ANIMATION),
                    new SpineAsset(PossessedGameAssets.BED_GRIL, PossessedGameAssets.BED_GRIL),
                    new SpineAsset(PossessedGameAssets.FS_INTRO_ANIMATION, PossessedGameAssets.FS_INTRO_ANIMATION),
                    new SpineAsset(PossessedGameAssets.HOTZONE_ANIMATION, PossessedGameAssets.HOTZONE_ANIMATION),
                    new SpineAsset(PossessedGameAssets.SCATTER_ANIMATION, PossessedGameAssets.SCATTER_ANIMATION),
                    new SpineAsset(PossessedGameAssets.ACTIVATOR_SYM_SPINE, PossessedGameAssets.ACTIVATOR_SYM_SPINE),
                    new SpineAsset(PossessedGameAssets.CRUCIFIX_SYMBOL_SPINE, PossessedGameAssets.CRUCIFIX_SYMBOL_SPINE),
                    new SpineAsset(PossessedGameAssets.BIG_WIN_SPINE, PossessedGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(PossessedGameAssets.SCATTER_REEL_ANTICIPATION_SPINE, PossessedGameAssets.SCATTER_REEL_ANTICIPATION_SPINE),
                    new SpineAsset(PossessedGameAssets.SYMBOL_REVEAL_ANIMATION, PossessedGameAssets.SYMBOL_REVEAL_ANIMATION),
                    new SpineAsset(PossessedGameAssets.WILD_NUDGE_ANIMATION, PossessedGameAssets.WILD_NUDGE_ANIMATION),
                    new SpineAsset(PossessedGameAssets.WILD_EXPANDED_ANIMATION, PossessedGameAssets.WILD_EXPANDED_ANIMATION),
                    new SpineAsset(PossessedGameAssets.WILD_EXPAND_REEL_ANTICIPATION, PossessedGameAssets.WILD_EXPAND_REEL_ANTICIPATION),
                    new SpineAsset(PossessedGameAssets.WILD_EXPAND_BLACK_PARTICLE, PossessedGameAssets.WILD_EXPAND_BLACK_PARTICLE),
                    new SpineAsset(PossessedGameAssets.REEL_CROSS_ANIMATION, PossessedGameAssets.REEL_CROSS_ANIMATION),
                    new SpineAsset(PossessedGameAssets.WIN_CAP_ANIMATION, PossessedGameAssets.WIN_CAP_ANIMATION),
                    new SpineAsset(PossessedGameAssets.MULTIPLIER_NUMBER_ANIMATION, PossessedGameAssets.MULTIPLIER_NUMBER_ANIMATION),
                    new SpineAsset(PossessedGameAssets.COMMON_REVEAL_ANIMATION, PossessedGameAssets.COMMON_REVEAL_ANIMATION),
                    new SpineAsset("spine/Infectious.json", "spine/Infectious.json"),
                    new SpineAsset("spine/crossLight.json", "spine/crossLight.json"),
                    new SpineAsset("spine/M1_cross.json", "spine/M1_cross.json"),
                    new SpineAsset("spine/transition_fire.json", "spine/transition_fire.json"),
                    new SpineAsset("spine/Fs_Outro.json", "spine/Fs_Outro.json"),
                    new SpineAsset("spine/FS_spins.json", "spine/FS_spins.json"),
                    new SpineAsset("spine/SFS_outro.json", "spine/SFS_outro.json"),
                    new SpineAsset("spine/greenAnticipation.json", "spine/greenAnticipation.json"),
                    new SpineAsset("spine/easterEgg.json", "spine/easterEgg.json"),
                    new SpineAsset(PossessedGameAssets.BACKGROUND_FIRE_ANIMATION, PossessedGameAssets.BACKGROUND_FIRE_ANIMATION),
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json")
                ],
                animations: {}
            },
            {
                autoLoad: [AssetQualityLevel.HIGH],
                name: "xbet",
                assets: [
                    new TextureAsset("xbet", "sheets/xbet/xbet0.json")
                ]
            }
        ]
    };
}